import { render, staticRenderFns } from "./fr-footer.vue?vue&type=template&id=4d3d8b42&"
import script from "./fr-footer.vue?vue&type=script&lang=js&"
export * from "./fr-footer.vue?vue&type=script&lang=js&"
import style0 from "./fr-footer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports